// @flow

export default function referralUrl() {
  return '/referral'
}
